import { CDN_IMG_URL } from '~/shared/cdn/url';

const getCdnImg = (src = '', ext = '') => `${CDN_IMG_URL}/${src}${ext}`;

export default getCdnImg;
